import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { UsersIcon, MoonIcon, SunIcon, HeartIcon } from 'lucide-react';
import { SectionWrapper } from '../ui/SectionWrapper';
const audiences = [{
  icon: UsersIcon,
  text: 'Familias con niños pequeños en proceso de aprender a controlar el pipí'
}, {
  icon: MoonIcon,
  text: 'Hogares con pipí nocturno frecuente'
}, {
  icon: SunIcon,
  text: 'Niños con escapes durante el día'
}, {
  icon: HeartIcon,
  text: 'Familias que buscan soluciones respetuosas, sin castigos'
}];
export function AudienceSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <SectionWrapper background="cream" data-id="element-32">
      <div ref={ref} className="grid md:grid-cols-2 gap-12 items-center" data-id="element-33">
        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={isInView ? {
        opacity: 1,
        x: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-34">
          <img src="https://cdn.magicpatterns.com/uploads/w6DzyNxkGxNS65xnCfdfVP/2._.png" alt="Madre usando tablet con la aplicación Noches Secas mientras su hijo juega" className="w-full h-auto rounded-2xl shadow-lg" data-id="element-35" />
        </motion.div>

        {/* Content */}
        <div data-id="element-36">
          <h2 className="font-serif text-3xl md:text-4xl text-navy mb-8" data-id="element-37">
            ¿Para quién es Noches Secas?
          </h2>

          <ul className="space-y-5 mb-8" data-id="element-38">
            {audiences.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: 20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            delay: 0.2 + index * 0.1
          }} className="flex items-start gap-4" data-id="element-39">
                <span className="flex-shrink-0 w-10 h-10 rounded-full bg-soft-blue/10 flex items-center justify-center" data-id="element-40">
                  <item.icon className="w-5 h-5 text-soft-blue" data-id="element-41" />
                </span>
                <span className="text-navy/80 text-lg pt-1.5" data-id="element-42">{item.text}</span>
              </motion.li>)}
          </ul>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          delay: 0.6
        }} className="bg-white border-l-4 border-gold p-6 rounded-r-xl shadow-sm" data-id="element-43">
            <p className="text-navy font-medium text-lg italic" data-id="element-44">
              "El cuerpo del niño no está fallando. Está aprendiendo."
            </p>
          </motion.div>
        </div>
      </div>
    </SectionWrapper>;
}